import { Component, ElementRef, ViewChild } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';

import { FormatNumberPipe } from '@shared/pipes/format-number.pipe';
import { FormFieldComponent } from '../form-field.types';

@Component({
  templateUrl: './percent-form-field.component.html',
  styleUrls: ['./../form-field.component.scss'],
})
export class PercentFormFieldComponent extends FormFieldComponent {
  @ViewChild('inputControl') inputControl: ElementRef;

  private valueMemento: string;
  private precision: number = 0;

  public editing: boolean = false;
  public valueControl = new UntypedFormControl();

  ngOnInit(): void {
    super.ngOnInit();

    if (this.fieldDef.meta && this.fieldDef.meta.scale) {
      this.precision = this.fieldDef.meta.scale;
    }

    if (this.isDisabled) {
      this.valueControl.disable();
    }

    this.setValues();
  }

  updateChangedModel(model: any): void {
    this.model = model;
    this.setValues();
  }

  edit(): void {
    if (!this.editing && !this.isReadonly) {
      this.editing = true;
      setTimeout(() => {
        this.inputControl.nativeElement.focus();
      }, 300);
    }
  }

  onBlur(event: Event & { target: { value: any } }): void {
    this.editing = false;

    const value = event?.target?.value ? String(Number(event.target.value)) : null;

    if (this.valueMemento === value) {
      return;
    }

    this.model[this.fieldDef.name] = value;
    this.update.emit({ [this.fieldDef.name]: value });
  }

  private setValues(): void {
    const value = this.fieldDef.meta?.value_hidden
      ? 'REDACTED'
      : new FormatNumberPipe().transform(this.model[this.fieldDef.name], this.precision, this.fieldDef);
    this.valueControl.setValue(value);
    this.valueMemento = value;
  }
}
